"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.InlineResponse20016ToJSON = exports.InlineResponse20016FromJSONTyped = exports.InlineResponse20016FromJSON = void 0;
function InlineResponse20016FromJSON(json) {
    return InlineResponse20016FromJSONTyped(json, false);
}
exports.InlineResponse20016FromJSON = InlineResponse20016FromJSON;
function InlineResponse20016FromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'isCancellable': json['isCancellable'],
        'hasCancelled': json['hasCancelled'],
    };
}
exports.InlineResponse20016FromJSONTyped = InlineResponse20016FromJSONTyped;
function InlineResponse20016ToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'isCancellable': value.isCancellable,
        'hasCancelled': value.hasCancelled,
    };
}
exports.InlineResponse20016ToJSON = InlineResponse20016ToJSON;
